import { create } from 'zustand';
import type { DriveRoot } from '../drive/source';

export type DriveStatus = 'off' | 'connecting' | 'connected' | 'error';

interface DriveState {
  status: DriveStatus;
  error: string | null;
  root: DriveRoot | null;
  /** True when a folder is configured but the Google session has lapsed, so the
   *  UI can prompt for one click instead of silently falling back to demo. */
  needsSignIn: boolean;
  set: (patch: Partial<Omit<DriveState, 'set'>>) => void;
}

export const useDrive = create<DriveState>((set) => ({
  status: 'off',
  error: null,
  root: null,
  needsSignIn: false,
  set: (patch) => set(patch),
}));
